import React, { useEffect, useRef } from 'react';
import './Background.css'; // Renamed CSS file

const Background = () => {
  const experiences = [
    {
      id: 1,
      duration: "June 2025 - Present",
      title: "Software Engineer",
      company: "ENSEK",
      icon: "/icons/ensek_logo.ico",
      description: "",
      technologies: ["C#", "SQL", ".NET Framework", "ASP.NET", "AWS", "React", "JavaScript/TypeScript"],
    },
    {
      id: 2,
      duration: "Nov 2022 - Dec 2024",
      title: "Software Developer",
      company: "Digi-Steel",
      icon: "/icons/digi-trash.ico",
      description: "At Digi-Steel I was involved in the development and maintenance of various (RESTful) APIs. All of which designed under a Microservices architecture and hosted on the AWS Cloud Service. Some of my responsibilities involved implementation of new features, bug fixing, investigation and testing of system improvements and data flow management. As a secondary role I also assumed responsibility of designing and implementing automation solutions for a full test coverage of all API services which was the backbone to the company's transition to a CI/CD work model. This included adding a multitude of integration tests and front end automation tests.",
      technologies: ["C#", "Python", ".NET Framework", "ASP.NET", "AWS", "Angular", "TypeScript", "Selenium"],
    },
    {
      id: 3,
      duration: "Jun 2021 - May 2022",
      title: "Software Developer",
      company: "Inspired Gaming Group",
      icon: "/icons/inspired.ico",
      description: "At Inspired Entertainment I was part of the development and release of a multiple of casino slots games. Mainly released on cab machines as stand-alone applications developed in C++ and XML with the use of an in-house built game engine. My tasks included implementation of game generation algorithms in accordance with strictly defined parameters by mathematicians, implementation of graphical assets and bug fixing.",
      technologies: ["C++", "XML", "Mathematics"],
    },
    {
      id: 4,
      duration: "June 2020 - June 2021",
      title: "Junior Backend Software Developer",
      company: "Codeweavers ltd",
      icon: "/icons/codeweavers.ico",
      description: "As a backend developer I was mainly involved in the integration of multiple (RESTful) APIs within the C# ASP.NET environment. Some of the work involved creating the necessary interfaces, DTOs, controllers and services strictly following the API documentation. The process also included working on the SQL based database to facilitate the addition of the necessary tables and stored procedures for storing and querying data. Other responsibilities included using Zendesk to assist with any client reported bugs in tech support, collaborating with POs, QAs and quite often directly with company clients to plan and organize the next new project in the backlog.",
      technologies: ["C#", "Python", ".NET Framework", "ASP.NET", "SQL Server", "NoSQL", "Apache Cassandra"],
    },
    {
      id: 5,
      duration: "May 2019 - April 2020",
      title: "Social Media and Marketing Assistant",
      company: "Easy Relocations ltd",
      icon: "/icons/Untitled.ico",
      description: "As a Social Media and Marketing assistant my responsibilities included managing the company's social media presence, designing and launching online advertisement campaigns and production of advertisement videos.",
      technologies: ["Canon EOS 5D", "Adobe Premier Pro", "Facebook Ads Manager", "Google Ads"],
    },
    {
      id: 6,
      duration: "March 2019 - May 2019",
      title: "Software Developer (Intern)",
      company: "Clubhub ltd",
      icon: "/icons/clubhub.ico",
      description: "At Clubhub, as a small startup company, I had the opportunity to be a part of a small team of three developers working on creating a mobile application. By utilizing geo-fencing, the application would send users relevant notifications of offers based on their location and preset preferences. A client facing web portal was developed through which business owners can set up an account through which they can send offers to nearby users of the application to attract them as clients. My responsibilities involved design, development and implementation of the mobile application utilizing Xamarin Forms with C#, setting up a NoSQL database using Google’s Firebase and the initial setup of the web portal through the use of React.",
      technologies: ["C#", ".NET Framework", "ASP.NET", "React", "TypeScript", "Firebase"],
    },
  ];

  const education = [
    {
      id: 1,
      duration: "2016 - 2020",
      degree: "BSc Computer Games Programming",
      institution: "University of Derby",
      icon: "/icons/university_of_derby_logo.jpg",
      description: "Graduated with a focus on software engineering and games development. Completed a set of courseworks in algorithms, data structures, and web development.",
      skills: ["Programming Fundamentals", "Databases", "Algorithms", "Data structures", "Project Managment", "Team Collaboration"],
    },
    {
      id: 2,
      duration: "2012 – 2014",
      degree: "Computer Networks - High School Diploma",
      institution: "Vocational Technical High School \"N. Vaptsarov\"",
      icon: "/icons/school-logo.jpg",
      description: "Participated in advanced placement courses in mathematics and computer science.",
      skills: ["Computer Hardware", "Software Development Fundamentals", "Network and Cybersecurity"],
    },
  ];

  const certifications = [
    {
      id: 1,
      dateEarned: "Aug 2023",
      title: "ISTQB® Certified Tester Foundation Level 2018",
      issuer: "ISTQB® - International Software Testing Qualifications Board",
      icon: "/icons/istqb_logo.jpg",
      credentialId: "00571730",
    }
  ];

 // Ref to track all entries
 const entryRefs = useRef([]);

 // Slide-in animation on scroll
  useEffect(() => {
   const observer = new IntersectionObserver(
     (entries) => {
       entries.forEach((entry) => {
         if (entry.isIntersecting) {
           entry.target.classList.add('slide-in');
           observer.unobserve(entry.target); // Stop observing once animated
         }
       });
     },
     { threshold: 0.1 } // Trigger when 10% of the element is visible
   );

   const currentEntries = entryRefs.current;

   currentEntries.forEach((entry) => {
     if (entry) observer.observe(entry);
   });

   return () => {
    currentEntries.forEach((entry) => {
       if (entry) observer.unobserve(entry);
     });
   };
  }, []);

 // Mouse-following rotation on hover for each container
  const handleMouseMove = (e, entry) => {
  const rect = entry.getBoundingClientRect();
  const entryCenterX = rect.left + rect.width / 2;
  const entryCenterY = rect.top + rect.height / 2;

  // Calculate mouse position relative to the center of the container
  const mouseX = e.clientX - entryCenterX;
  const mouseY = e.clientY - entryCenterY;

  // Calculate rotation angles for X and Y axes
  const maxRotation = 30; // Maximum rotation in degrees
  const rotateY = (mouseX / rect.width) * maxRotation; // Horizontal tilt
  const rotateX = -(mouseY / rect.height) * (maxRotation * 1.5); // Vertical tilt (negative to tilt naturally)

  // Apply 3D rotation
  entry.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = (entry) => {
    entry.style.transform = 'rotateX(0deg) rotateY(0deg)'; // Reset to flat position
  };

  return (
    <section id="background" className="background-section">
      <h1 className="backgroud-title-box">BACKGROUND</h1>
      <div className="background-container">
        <div className="left-column-wrapper">
          <div className="education-column">
            <h2>Education</h2>
            {education.map((edu, index) => (
              <div
                key={edu.id}
                className="education-entry"
                ref={(el) => (entryRefs.current[index] = el)}
                onMouseMove={(e) => handleMouseMove(e, entryRefs.current[index])}
                onMouseLeave={() => handleMouseLeave(entryRefs.current[index])}
              >
                <div className="entry-header">
                  <div className="left-column">
                    <span className="duration">{edu.duration}</span>
                    <div className="institution-info">
                      <img src={edu.icon} alt={`${edu.institution} icon`} className="institution-icon" />
                      <span>{edu.institution}</span>
                    </div>
                  </div>
                  <div className="right-column">
                    <h3>{edu.degree}</h3>
                    <div className="entry-description">
                      <p>{edu.description}</p>
                    </div>
                    <div className="skills">
                      {edu.skills.map((skill, index) => (
                        <span key={index} className="skill-tag">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="certifications-column">
            <h2>Certifications</h2>
            {certifications.map((cert, index) => (
              <div
                key={cert.id}
                className="certification-entry"
                ref={(el) => (entryRefs.current[education.length + index] = el)}
                onMouseMove={(e) => handleMouseMove(e, entryRefs.current[education.length + index])}
                onMouseLeave={() => handleMouseLeave(entryRefs.current[education.length + index])}
              >
                <div className="entry-header">
                  <div className="left-column">
                    <span className="date-earned">{cert.dateEarned}</span>
                    <div className="issuer-info">
                      <img src={cert.icon} alt={`${cert.issuer} icon`} className="issuer-icon" />
                      <span>{cert.issuer}</span>
                    </div>
                  </div>
                  <div className="right-column">
                    <h3>{cert.title}</h3>
                    <div className="entry-details">
                      <p><strong>Credential ID:</strong> {cert.credentialId}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="experience-column">
          <h2>Experience</h2>
          {experiences.map((exp, index) => (
            <div
              key={exp.id}
              className="experience-entry"
              ref={(el) => (entryRefs.current[education.length + certifications.length + index] = el)}
              onMouseMove={(e) => handleMouseMove(e, entryRefs.current[education.length + certifications.length + index])}
              onMouseLeave={() => handleMouseLeave(entryRefs.current[education.length + certifications.length + index])}
            >
              <div className="entry-header">
                <div className="left-column">
                  <span className="duration">{exp.duration}</span>
                  <div className="company-info">
                    <img src={exp.icon} alt={`${exp.company} icon`} className="company-icon" />
                    <span>{exp.company}</span>
                  </div>
                </div>
                <div className="right-column">
                  <h3>{exp.title}</h3>
                  <div className="entry-description">
                    <p>{exp.description}</p>
                  </div>
                  <div className="technologies">
                    {exp.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Background;